<template>
  <div>
    <div class="content" style="width:auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ typeName }}</span>
      </div>
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width:88%;display: flex">
            <div class="start-label" />
            <span class="text">计划基础信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="保养计划编号" prop="no">
                <el-input disabled v-model="form.no" placeholder="系统自动生成保养计划编号" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="保养计划名称" prop="name">
                <el-input :disabled="!editMode" v-model="form.name" placeholder="请填写保养计划名称" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="保养模板" prop="maintainModuleName">
                <el-select :disabled="!editMode" v-model="form.maintainModuleName" style="width: 90%" filterable :filter-method="getMaintainModules" placeholder="请选择保养模板" @change="maintainModuleChange">
                  <el-option v-for="item in maintainModules" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="保养有效期" prop="dateRange">
                <el-date-picker :disabled="!editMode" style="width: 90%" v-model="form.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="dateChange" :picker-options="{
                    disabledDate(v) {
                      return receivingDisabledDate(v);
                    },
                  }">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="保养责任科室" prop="deptName">
                <el-select :disabled="!editMode" v-model="form.deptName" style="width: 90%" filterable placeholder="请选择保养责任科室" :filter-method="getDepts" @change="deptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="保养责任人" prop="dutyUserName">
                <el-select :disabled="!editMode" v-model="form.dutyUserName" style="width: 90%" filterable placeholder="请选择保养责任人" :filter-method="getUsersByDept" @change="dutyUserChange">
                  <el-option v-for="item in STATIC_DeptUsers" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否循环" prop="isLoop">
                <el-select :disabled="!editMode" v-model="form.isLoop" style="width: 90%" placeholder="请选择是否循环">
                  <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="保养循环周期(天)" :prop="form.isLoop == 1 ? 'day' : ''">
                <el-input-number :disabled="!editMode || form.isLoop != 1" v-model="form.day" :min="0" :precision="0" :controls="false" placeholder="请填写保养循环周期" style="width: 90%"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="预计保养费用" prop="estimateToTalAmount">
                <el-input-number disabled v-model="form.estimateToTalAmount" :min="0" :precision="4" :controls="false" placeholder="根据子表费用明细汇总" style="width: 90%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="实际保养费用" prop="toTalAmount">
                <el-input-number disabled v-model="form.toTalAmount" :min="0" :precision="4" :controls="false" placeholder="根据已执行的保养计划汇总" style="width: 90%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人" prop="createdUserName">
                <el-input v-model="form.createdUserName" disabled style="width:90%" placeholder="系统默认为当前操作人员"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="createdTime">
                <el-date-picker disabled v-model="form.createdTime" style="width: 90%" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="系统默认为当前时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" v-model="form.remark" placeholder="请填写备注" type="textarea" resize="none" :rows="5" style="width:95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <InvoiceEdit></InvoiceEdit>

        <AssetInfoEdit ref="AssetInfoEditRef" :data="form.details" :canEdit="editMode" :ParentForm="form" :FixedAssetParam="{ deptId: form.deptId }" @autoTotalAmount="autoTotalAmount" :isWorkOrder="true" WorkOrderAmountName="保养" :showDimension="true" :assetCardMultiple="false" :isRepeatMethod="isRepeatMethod" isRepeatMsg="当前资产信息已存在，请去子表编辑！">
        </AssetInfoEdit>
        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="$router.go(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetMaintainPlanById,
  SaveMaintainPlan,
  RejectMaintainPlan,
  GetMaintainModules,
  GetExecutePlanById,
  RejectExecutePlan,
} from "@/api";
import { WarehouseOutStockOptions, WhetherOptions } from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import AssetInfoEdit from "@/components/asset-into-edit";
import InvoiceEdit from "@/components/invoice-edit";
export default {
  mixins: [GetDataMixin],
  components: {
    SelectTable,
    ApproveInfo,
    AssetInfoEdit,
    InvoiceEdit,
  },
  /** 定义属性 */
  data () {
    return {
      typeName: "保养计划",
      form: {},
      WarehouseOutStockOptions: WarehouseOutStockOptions,
      rules: {
        name: [
          { required: true, message: "保养计划名称不能为空", trigger: "blur" },
        ],
        maintainModuleName: [
          { required: true, message: "保养模板不能为空", trigger: "blur" },
        ],
        dateRange: [
          { required: true, message: "保养有效期不能为空", trigger: "blur" },
        ],
        deptName: [
          { required: true, message: "保养责任科室不能为空", trigger: "blur" },
        ],
        dutyUserName: [
          { required: true, message: "保养责任人不能为空", trigger: "blur" },
        ],
        isLoop: [
          { required: true, message: "是否循环不能为空", trigger: "blur" },
        ],
        day: [
          { required: true, message: "保养循环周期不能为空", trigger: "blur" },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      assetList: [],
      reject: null,
      maintainModules: [],
      WhetherOptions: WhetherOptions,
    };
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {},
  /** 方法集合 */
  methods: {
    InitData () {
      var query = this.$route.query;
      if (query.category) {
        this.category = query.category;
      }
      if (query.id) {
        this.handleUpdate(query.id);
      } else {
        this.handleAdd();
      }
    },
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      switch (this.category) {
        case "1":
          this.reject = RejectMaintainPlan;
          GetMaintainPlanById({ id }).then((res) => {
            // this.resetForm()
            this.form = res.returnData;
            this.$set(this.form, "dateRange", [
              this.form.date,
              this.form.endDate,
            ]);
            if (!this.form.details) {
              this.form.details = [];
            }
            this.form.details.forEach((e, index) => {
              e.$index = index + 1;
            });
            this.$refs.AssetInfoEditRef.setDetalis(this.form.details);
            this.initWorkFlowProperty(this.form);
          });
          break;
        case "2":
          this.reject = RejectExecutePlan;
          GetExecutePlanById({ id }).then((res) => {
            // this.resetForm()
            this.form = res.returnData;
            this.form.dateRange = [this.form.date, this.form.endDate];
            if (!this.form.details) {
              this.form.details = [];
            }
            this.form.details.forEach((e, index) => {
              e.$index = index + 1;
            });

            this.$refs.AssetInfoEditRef.setDetalis(this.form.details);
            this.initWorkFlowProperty(this.form);
            this.form.details.forEach((e, index) => {
              e.$index = index + 1;
            });
          });
          break;
      }
    },
    /**
     * 初始化表单
     */
    resetForm () {
      this.form = {
        dateRange: [
          this.parseTime(new Date(), "{y}-{m}-{d}"),
          this.parseTime(new Date(), "{y}-{m}-{d}"),
        ],
        createdUserName: this.userInfo.name,
        createdTime: this.parseTime(new Date(), "{y}-{m}-{d} {h}:{i}:{s}"),
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        warehouseId: null,
        warehouseName: null,
        warehouseManagerId: null,
        warehouseManagerName: null,
        backWarehouseId: null,
        backWarehouseName: null,
        backWarehouseManagerId: null,
        backWarehouseManagerName: null,
        userName: null,
        phone: null,
        toTalNumber: null,
        totalAmount: 0,
        details: [],
        isLoop: 0,
        orgCode :sessionStorage.getItem('orgId')
      };
    },
    // 保存
    submit () {
      this.form.details = this.$refs.AssetInfoEditRef.getDetails();
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveMaintainPlan(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          this.$router.push({ path: this.getMainPath(this.$route.path) });
        });
      });
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },
    /**
     * 原库房选择
     */
    warehouseChange (val) {
      let item = this.STATIC_Warehouses.find((e) => e.id == val);
      if (item) {
        this.form.warehouseId = item.id;
        this.form.warehouseManagerId = item.managerId;
        this.form.warehouseManagerName = item.managerName;
      }
    },
    /**
     * 调回库房选择
     */
    backWarehouseChange (val) {
      let item = this.STATIC_Warehouses.find((e) => e.id == val);
      if (item) {
        this.form.backWarehouseId = item.id;
        this.form.backWarehouseManagerId = item.managerId;
        this.form.backWarehouseManagerName = item.managerName;
      }
    },
    autoTotalAmount (e) {
      this.form.details = e;
      let toTalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        toTalNumber = toTalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.fees * 1;
        e[index].unBillNumber = element.number;
        e[index].unBillAmount = element.fees;
      });
      this.form.toTalNumber = toTalNumber;
      this.form.estimateToTalAmount = totalAmount;
      this.form.unBillNumber = toTalNumber;
      this.form.unBillAmount = totalAmount;
    },
    /**
     * 明细表添加
     */
    handleAddChildForm () {
      if (!this.form.details) {
        this.form.details = [];
      }
      this.openSubformModal = true;
      this.resetDetailFormData();
    },
    /**
     * 保养模板选择
     */
    maintainModuleChange (val) {
      this.form.maintainModuleId = val;
    },
    dateChange (val) {
      //   window.console.log(val);
      //  if (new Date().setHours(0, 0, 0, 0) > new Date(val[1]).valueOf()) {
      //    alert("结束日期不能小于当前日期")
      //  }
      if (val) {
        this.$set(this.form, "date", val[0]);
        this.$set(this.form, "endDate", val[1]);
      } else {
        this.$set(this.form, "date", null);
        this.$set(this.form, "endDate", null);
      }
    },
    receivingDisabledDate (v) {
      return v.valueOf() < new Date().setHours(0, 0, 0, 0);
    },
    deptChange (val) {
      this.form.deptId = val;
      this.$set(this.form, "dutyUserId", null);
      this.$set(this.form, "dutyUserName", null);
      var item = this.STATIC_Depts.find((t) => t.id == val);
      if (item) {
        this.$set(this.form, "dutyUserId", item.leader);
        this.$set(this.form, "dutyUserName", item.leaderName);
      }
      this.getUsersByDept();
    },
    dutyUserChange (val) {
      this.form.dutyUserId = val;
    },
    getMaintainModules (keyWord) {
      let query = { ...this.defaultAllQueryParams };
      query.keyWord = keyWord;
      GetMaintainModules(query).then((res) => {
        this.maintainModules = res.returnData.data;
      });
    },
    getUsersByDept (keyWord) {
      return this.getDeptUsers(this.form.deptId, keyWord);
    },
    isRepeatMethod (arr, row) {
      let item = arr.find(
        (e) =>
          e.$index != row.$index &&
          e.$index != row.$index &&
          e.assetId == row.assetId &&
          e.price == row.price &&
          e.locationName == row.locationName &&
          e.assetSource == row.assetSource &&
          e.packDesc == row.packDesc &&
          e.manufacturerId == row.manufacturerId &&
          e.certId == row.certId &&
          e.brandId == row.brandId
      );
      if (item) {
        return true;
      } else {
        return false;
      }
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.InitData();
  },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () {
    this.getDepts();
    this.getMaintainModules();
    this.$refs.AssetInfoEditRef.getFixedAssetList();
    // this.$refs.AssetInfoEditRef.getAssetCards();
    this.getWarehouses();
  },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped></style>
